import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { noop } from 'ui-components/default-props/noop';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';

import style from './style.module.less';

export const ShipStationTermsAndConditionsModal = ({ modalFrameworkMethods, onAcceptTerms = noop }) => {
  const { closeModal } = modalFrameworkMethods;
  return (
    <Modal>
      <ModalHeader closeModal={closeModal}>
        <FormattedMessage defaultMessage='Terms & Conditions' description='termsAndConditions.header' id='WFE6UX' />
      </ModalHeader>
      <ModalBody className={style['terms-body']}>
        <div className={style['instruction-wrapper']}>
          <div className={style['logo-wrapper']}>
            <img alt='ShipStation' src='https://logos.shipstation.com/marketplaces/shipstation/color.svg' />
          </div>
          <div>
            <FormattedMessage
              defaultMessage='Please read the terms and conditions below.'
              description='termsAndConditions.instructions'
              id='ErlMdq'
            />
          </div>
        </div>
        <iframe height='400' src='https://www.shipstation.com/terms-iframe/' title='terms-and-conditions' width='760' />
      </ModalBody>
      <ModalFooter className={style['terms-footer']}>
        <Button
          onClick={() => {
            onAcceptTerms();
            closeModal();
          }}
          theme='primary'
        >
          <FormattedMessage defaultMessage='Accept ShipStation Terms and Conditions' description='termsAndConditions.accept' id='3h+L4F' />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ShipStationTermsAndConditionsModal.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
  onAcceptTerms: PropTypes.func,
};
